import phone from '../../api/phone'

export default {
    namespaced: true,
    state: () => ({
        color: null,
        button: 'Ajouter à l\'estimation',
        loading: false,
        insurances: [],
        item: null
    }),
    getters: {},
    actions: {
        getPhone ({ commit }, query) {
            commit('setLoading', true)
            return phone.getPhone(query).then((response) => {
                commit('setButton', response.data.button)
                commit('setItem', response.data.phone)
                commit('setLoading', false)
            })
        },
        getInsurances ({ commit }) {
            commit('setLoading', true)
            return phone.getInsurances().then((response) => {
                commit('setInsurances', response.data.insurances)
                commit('setLoading', false)
            })
        },
        updatePhonePermalink ({ commit }, permalink) {
            commit('setPhonePermalink', permalink)
        },
        saveEstimate ({ commit, state }) {
            commit('setLoading', true)
            return phone.saveEstimate(state.item).then((response) => {
                window.location.href = response.data.redirect
            })
        },
        removeSubscription ({ commit }) {
            commit('removeSubscription')
        },
        setColor ({ commit }, color) {
            commit('setColor', color)
        }
    },
    mutations: {
        setLoading (state, bool) {
            state.loading = bool
        },
        setItem (state, data) {
            state.item = data
        },
        setButton (state, data) {
            state.button = data
        },
        setInsurances (state, data) {
            state.insurances = data
        },
        removeSubscription (state) {
            state.item.defaults.subscription = null
        },
        setColor (state, color) {
            state.color = color
        },
        setPhonePermalink (state, permalink) {
            state.item.permalink = permalink
        }
    }
}
